<template>
  <md-card>
    <md-card-header class="dark-header">
      <h4 class="title">Danh sách đại lý</h4>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <md-button class="md-success button-add" @click="addNewCustomer"
          >Thêm đại lý</md-button
        >
      </div>
      <div class="md-layout">
        <!-- <div class="md-layout-item md-size-25">
					<md-field>
						<label>Tỉnh/Thành phố</label>
						<md-select v-model="filter.province">
							<md-option
								:key="index"
								v-for="(item, index) in suggesstion.province"
								:value="item">{{ item }}
							</md-option>
						</md-select>
					</md-field>
        </div>-->
        <div class="md-layout-item md-size-25">
          <md-autocomplete
            v-model="filter.province"
            :md-options="suggesstion.province"
            :md-open-on-focus="true"
            @md-selected="
              listCustomer = [];
              pagination.currentPage = 1;
              getData(pagination.perPage * 2);
            "
          >
            <label>Tỉnh thành phố</label>

            <template slot="md-autocomplete-empty" slot-scope="{ term }"
              >"{{ term }}" không tồn tại</template
            >
          </md-autocomplete>
        </div>
        <div class="md-layout-item md-size-25">
          <md-autocomplete
            v-model="filter.employeeName"
            :md-options="listEmployeeName"
            :md-open-on-focus="true"
            @md-selected="
              (listCustomer = []), getData(pagination.perPage * 2);
              pagination.currentPage = 1;
            "
          >
            <label>Tên nhân viên</label>

            <template slot="md-autocomplete-empty" slot-scope="{ term }"
              >"{{ term }}" không tồn tại</template
            >
          </md-autocomplete>
        </div>
        <div class="md-layout-item md-size-25">
          <md-autocomplete
            v-model="filter.customerName"
            :md-options="listCustomerName"
            :md-open-on-focus="true"
            @md-selected="
              (listCustomer = []), getData(pagination.perPage * 2);
              pagination.currentPage = 1;
            "
          >
            <label>Tên đại lý</label>

            <template slot="md-autocomplete-empty" slot-scope="{ term }"
              >"{{ term }}" không tồn tại</template
            >
          </md-autocomplete>
        </div>
      </div>
      <div class="scroll-x">
        <table id="customer">
          <tr>
            <th>STT</th>
            <th>Mã đại lý</th>
            <th>Tên đại lý</th>
            <th>Tỉnh/Thành phố</th>
            <th>Số điện thoại</th>
            <th class="nummeric">Hạn mức công nợ</th>
            <th>Nhân viên</th>
            <th>Mã nhân viên</th>
            <th></th>
          </tr>
          <tr
            :key="index"
            v-for="(item, index) in queriedData"
            class="clickable"
          >
            <td>{{ listCustomer.indexOf(item) + 1 }}</td>
            <td @click="handleEdit(item)">{{ item.data.customerId }}</td>
            <td @click="handleEdit(item)">{{ item.data.customerName }}</td>
            <td @click="handleEdit(item)">{{ item.data.province }}</td>
            <td @click="handleEdit(item)">{{ item.data.phone }}</td>
            <td @click="handleEdit(item)" class="nummeric">
              {{ formatNumber(item.data.debtLimit) }}
            </td>
            <td @click="handleEdit(item)">{{ item.data.employeeName }}</td>
            <td @click="handleEdit(item)">{{ item.data.employeeCode }}</td>
            <td style="color: red" @click="removeItem(item)">
              <i class="far fa-trash-alt"></i>
              <md-tooltip>Xóa</md-tooltip>
            </td>
          </tr>
        </table>
      </div>
    </md-card-content>
    <md-card-actions md-alignment="space-between">
      <div class>
        <p class="card-category">
          Hiển thị Đại lý từ {{ from + 1 }} đến {{ to }}
        </p>
      </div>
      <span v-show="queriedData.length < pagination.perPage"
        >Đã tải hết dữ liệu</span
      >
      <!-- <div class="pagination clickable">
        <div
          style="margin-right: 10px;"
          @click="previusPage"
          v-show="pagination.currentPage !== 1"
          class="md-alignment-center-center md-layout"
        >
          <md-button class="md-simple md-sm">
            <i class="fas fa-angle-double-left"></i>
          </md-button>
        </div>
        <div
          @click="nextPage"
          v-show="queriedData.length === pagination.perPage"
          class="md-alignment-center-center md-layout"
        >
          <md-button class="md-simple md-sm">
            <i class="fas fa-angle-double-right"></i>
          </md-button>
        </div>
      </div> -->
      <pagination
        class="pagination-no-border pagination-success"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      >
      </pagination>
    </md-card-actions>
  </md-card>
</template>
<script>
import { Pagination } from "@/components";
import firebase from "@/services/firebase-init.js";
import Swal from "sweetalert2";
import EventBus from "../../EventBus.js";
export default {
  components: { Pagination },
  mounted() {
    this.$store.dispatch("FLAG_LOADING", true);
    this.db = firebase.firestore();
    this.db
      .collection(process.env.VUE_APP_SUGGESTION_LIST)
      .doc("customer")
      .get()
      .then((doc) => {
        if (doc.exists) {
          doc.data().province.forEach((item) => {
            this.suggesstion.province.push(item);
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    let bits = localStorage.getItem("bits");
    this.db
      .collection("--stats--")
      .doc(process.env.VUE_APP_LIST_CUSTOMER + bits)
      .get()
      .then((doc) => {
        if (doc.exists) {
          doc.data().listCustomer.forEach((item) => {
            this.listCustomerName.push(item.customerName);
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    this.db
      .collection(process.env.VUE_APP_USER + bits)
      .orderBy("name", "asc")
      .get()
      .then((doc) => {
        doc.forEach((item) => {
          this.listEmployeeName.push(item.data().name);
        });
      })
      .catch((error) => {
        console.log(error);
      });
    this.getData(this.pagination.perPage * 2);
    EventBus.$on("reloadCustomer", (customerId) => {
      this.replaceCustomer(customerId);
    });
    EventBus.$on("addNewCustomer", () => {
      this.listCustomer = [];
      this.getData(this.pagination.perPage * 2);
      this.db
        .collection("--stats--")
        .doc(process.env.VUE_APP_LIST_CUSTOMER + bits)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.listCustomerName = [];
            doc.data().listCustomer.forEach((item) => {
              this.listCustomerName.push(item.customerName);
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  },
  data() {
    return {
      pagination: {
        perPage: 40,
        currentPage: 1,
        total: 0,
      },
      listCustomer: [],
      db: null,
      listEmployeeName: [],
      listCustomerName: [],
      suggesstion: {
        province: [],
      },
      filter: {
        province: "",
        employeeName: "",
        customerName: "",
      },
    };
  },
  methods: {
    replaceCustomer(customerId) {
      let bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_CUSTOMER + bits)
        .where("customerId", "==", customerId)
        .get()
        .then((doc) => {
          doc.forEach(async (item) => {
            var index = await this.listCustomer.findIndex(function (customer) {
              return customer.data.customerId === customerId;
            });
            console.log(index);
            this.listCustomer[index].data = item.data();
          });
        });
    },
    getData(num) {
      let bits = localStorage.getItem("bits");
      let query = this.db.collection(process.env.VUE_APP_CUSTOMER + bits);
      if (this.filter.province !== "" && this.filter.customerName === "") {
        query = query.where("province", "==", this.filter.province);
      }
      if (this.filter.employeeName !== "" && this.filter.customerName === "") {
        query = query.where("employeeName", "==", this.filter.employeeName);
      }
      if (this.filter.customerName !== "") {
        query = query.where("customerName", "==", this.filter.customerName);
      }
      this.$store.dispatch("FLAG_LOADING", true);
      query
        .where(
          "customerId",
          ">",
          this.listCustomer[this.listCustomer.length - 1]
            ? this.listCustomer[this.listCustomer.length - 1].data.customerId
            : ""
        )
        .limit(num ? num : this.pagination.perPage)
        .get()
        .then((doc) => {
          doc.forEach((item) => {
            this.listCustomer.push({
              id: item.id,
              data: item.data(),
            });
          });
          this.$store.dispatch("FLAG_LOADING", false);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    previusPage() {
      if (this.pagination.currentPage !== 1) {
        this.pagination.currentPage--;
      }
    },
    async nextPage() {
      if (
        this.queriedData[this.queriedData.length - 1] ===
          this.listCustomer[
            this.listCustomer.length - 1 - this.pagination.perPage
          ] &&
        this.queriedData.length === this.pagination.perPage
      ) {
        this.pagination.currentPage++;
        await this.getData(null);
      } else if (
        this.queriedData[this.queriedData.length - 1] !==
        this.listCustomer[this.listCustomer.length - 1]
      )
        this.pagination.currentPage++;
    },
    handleEdit(item) {
      this.$emit("editCustomer", item);
    },
    addNewCustomer() {
      this.$emit("addCustomer");
    },
    removeItemInStats(item, bits) {
      let index = this.listCustomerName.indexOf(item.data.customerName);
      this.listCustomerName.splice(index, 1);
      this.db
        .collection("--stats--")
        .doc(process.env.VUE_APP_LIST_CUSTOMER + bits)
        .update({
          listCustomer: firebase.firestore.FieldValue.arrayRemove({
            customerId: item.data.customerId,
            customerName: item.data.customerName,
          }),
        })
        .catch(function (error) {
          console.error(
            "Error removing document in --stats--.process.env.VUE_APP_LIST_CUSTOMER + bits ( ",
            error + ")"
          );
        });
    },
    removeItem(item) {
      Swal.fire({
        title: "Xóa mục",
        text: `Mục này sẽ bị xóa khỏi danh sách`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let bits = localStorage.getItem("bits");
          this.db
            .collection(process.env.VUE_APP_CUSTOMER + bits)
            .doc(item.id)
            .delete()
            .then(() => {
              this.$messageSuccess("Xóa mục Đại lý thành công");
              //console.log(item);
              this.removeItemInStats(item, bits);
              this.getData(1);
              this.listCustomer.splice(this.listCustomer.indexOf(item), 1);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
  },
  computed: {
    queriedData() {
      let result = this.listCustomer;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.listCustomer.length;
    },
  },
  watch: {
    "pagination.currentPage"() {
      if (
        this.pagination.currentPage >=
        this.total / this.pagination.perPage - 1
      ) {
        this.getData(this.pagination.perPage);
      }
    },
  },
  destroyed() {
    // Stop listening the event hello with handler
    EventBus.$off();
  },
};
</script>
<style lang="css" scoped>
.button-add {
  position: absolute;
  top: 10px;
  right: 10px;
}

.danger {
  background-color: rgba(219, 110, 88, 0.329);
}
.table-border {
  border: solid rgba(0, 0, 0, 0.178) 1px;
  border-radius: 10px;
}
#customer {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  border-radius: 10px;
  overflow-x: scroll;
}

#customer td,
#customer th {
  padding: 8px 10px 8px 10px;
  border: 1px solid #ddd;
  max-width: 20vw;
}

#customer tr:nth-child(even) {
  background-color: #f2f2f2;
}

#customer tr:hover {
  background-color: #ddd;
}

#customer th {
  text-align: left;
  background-color: rgba(0, 165, 14, 0.356);
  color: rgb(0, 0, 0);
  font-style: normal;
  font-weight: normal;
}
.nummeric {
  text-align: right !important;
}
.pagination {
  color: rgba(0, 0, 0, 0.301);
  font-size: 13px;
}
</style>
